/**
 * Datumnotaties voor de kalender. De speeldata van een ronde staan er kort in
 * ("25–26 nov"), een aftrap met tijd ("25 nov · 21:00") en een sync met de dag
 * erbij als hij niet van vandaag is.
 */

// De app is Nederlands: een aftrap staat in Nederlandse tijd, ongeacht waar de
// browser van de beheerder staat.
const ZONE = 'Europe/Amsterdam';
const DAY_MONTH = { day: 'numeric', month: 'short', timeZone: ZONE };
const TIME = { hour: '2-digit', minute: '2-digit', timeZone: ZONE };

// Sportmonks levert "2025-11-25 21:00:00" in UTC. Zonder de 'Z' leest JavaScript
// dat als lokale tijd, en dan staat elke aftrap er een uur naast.
const SPORTMONKS_DATE = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}$/;

/** Zet een Firestore-timestamp of een Sportmonks-datumstring om in een Date. */
export function parseDate(value) {
    if (!value) return null;
    if (typeof value.toDate === 'function') return value.toDate();

    const date = typeof value === 'string' && SPORTMONKS_DATE.test(value)
        ? new Date(`${value.replace(' ', 'T')}Z`)
        : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

const asDate = parseDate;

function isSameDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

/** "25 nov" — de dag zonder jaar, want binnen een seizoen is dat nooit de vraag. */
export function formatDay(value) {
    const date = asDate(value);
    return date ? date.toLocaleDateString('nl-NL', DAY_MONTH) : '—';
}

/** "25–26 nov" of "30 sep – 1 okt"; één dag geeft gewoon die dag. */
export function formatDateRange(from, to) {
    const start = asDate(from);
    const end = asDate(to);
    if (!start) return '—';
    if (!end || isSameDay(start, end)) return formatDay(start);

    if (start.getMonth() === end.getMonth()) {
        return `${start.getDate()}–${end.toLocaleDateString('nl-NL', DAY_MONTH)}`;
    }
    return `${formatDay(start)} – ${formatDay(end)}`;
}

/** "25 nov · 21:00" — de aftrap van een wedstrijd. */
export function formatKickoff(value) {
    const date = asDate(value);
    if (!date) return '—';
    return `${date.toLocaleDateString('nl-NL', DAY_MONTH)} · ${date.toLocaleTimeString('nl-NL', TIME)}`;
}

/** "vandaag 09:02" of "26 nov 09:14" — wanneer er voor het laatst iets gebeurde. */
export function formatMoment(value) {
    const date = asDate(value);
    if (!date) return 'nog niet';
    const time = date.toLocaleTimeString('nl-NL', TIME);
    if (isSameDay(date, new Date())) return `vandaag ${time}`;
    return `${date.toLocaleDateString('nl-NL', DAY_MONTH)} ${time}`;
}
